import api from "../api";

export interface CityRequest {
  city: string;
  created_at?: string;
  id: number | string;
  organization: string;
  population: string;
  province: string;
  status: string;
  updated_at?: string;
  updated_by?: string;
}

function fromBackendPayload(data: any): CityRequest {
  return {
    city: data.city,
    created_at: data.created_at,
    id: data.id,
    organization: data.organization,
    population: data.population,
    province: data.province,
    status: data.status,
    updated_at: data.updated_at,
    updated_by: data.updated_by,
  };
}

function toBackendPayload(request: CityRequest) {
  return {
    city: request.city,
    organization: request.organization,
    population: request.population,
    province: request.province,
    status: request.status,
  };
}

export const CityRequestsService = {
  async create(request: CityRequest): Promise<CityRequest> {
    const res = await api.post("/city-requests", toBackendPayload(request));
    return fromBackendPayload(res.data.request);
  },
  async delete(id: number | string): Promise<void> {
    await api.delete(`/city-requests/${id}`);
  },
  async getAll(): Promise<CityRequest[]> {
    const res = await api.get("/city-requests");
    return (res.data.requests || []).map(fromBackendPayload);
  },
  async getById(id: number | string): Promise<CityRequest> {
    const res = await api.get(`/city-requests/${id}`);
    return fromBackendPayload(res.data.request);
  },
  async updateStatus(
    id: number | string,
    status: string,
  ): Promise<CityRequest> {
    const res = await api.post(`/city-requests/${id}/status`, { status });
    return fromBackendPayload(res.data.request);
  },
};
